import Smartphones from 'Overview/ClientOverview/views/containers/Smartphones'
import Tablets from 'Overview/ClientOverview/views/containers/Tablets'

import { getCurrentDeviceView } from 'shared/helpers/utils'

const ClientOverviewView = getCurrentDeviceView(Smartphones, Tablets)

export default ClientOverviewView
